import React from 'react'
import classNames from 'classnames'
import { isEmpty } from 'lodash'
import { IconCircleDot, IconX, IconSparkles } from '@tabler/icons-react'

import { Pill } from '@/components/pills/Pill'

const NODE_ICON = {
  goal: IconCircleDot,
  obstacle: IconX,
  fix: IconSparkles,
}

const NODE_VARIANT = {
  goal: { magical: true },
  obstacle: { critical: true },
  fix: { success: true },
}

// The connected goal → obstacle → fix spine that makes an insight legible in one
// read. Used on the Insights card and, minus the fix node, on the reason drawer.
// `nodes` is an ordered list of { kind: 'goal'|'obstacle'|'fix', lead, value }.
// A node may also carry `items` (an array of strings) to render its value as a
// bulleted list instead of prose — the drawer uses this to show the per-sentence
// recommendation steps, while the card keeps the prose `value`.
export const Spine = ({ nodes }) => (
  <div className="insight-spine">
    {nodes.map((node) => {
      const Icon = NODE_ICON[node.kind]
      return (
        <div key={node.kind} className="insight-spine__node">
          <Pill
            circular
            small
            className="insight-spine__icon"
            icon={<Icon className="icon-svg" />}
            {...NODE_VARIANT[node.kind]}
          />
          <p className="insight-spine__lead">{node.lead}</p>
          {isEmpty(node.items) ? (
            <p
              className={classNames('insight-spine__value', {
                'insight-spine__value--clamp': node.clamp,
              })}
            >
              {node.value}
            </p>
          ) : (
            <ul className="insight-spine__list">
              {node.items.map((item) => (
                <li key={item} className="insight-spine__list-item">
                  {item}
                </li>
              ))}
            </ul>
          )}
        </div>
      )
    })}
  </div>
)
